module.exports = __webpack_public_path__ + "img/221121-bimistock----pk-1@1x.e572e9d1.png";